import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 20000 });

export const api = {
  countries: () => client.get("/countries").then((r) => r.data),
  tags: (limit = 80) => client.get("/tags", { params: { limit } }).then((r) => r.data),
  languages: (limit = 60) => client.get("/languages", { params: { limit } }).then((r) => r.data),
  topStations: (limit = 48) => client.get("/stations/top", { params: { limit } }).then((r) => r.data),
  searchStations: (params) => client.get("/stations/search", { params }).then((r) => r.data),
  stationsByCountry: (country, limit = 120) =>
    client.get(`/stations/bycountry/${encodeURIComponent(country)}`, { params: { limit } }).then((r) => r.data),
  randomStation: (params = {}) => client.get("/stations/random", { params }).then((r) => r.data),
  stationByUuid: (uuid) => client.get(`/stations/byuuid/${uuid}`).then((r) => r.data),
  nowPlaying: (url) => client.get("/stations/nowplaying", { params: { url }, timeout: 8000 }).then((r) => r.data),
  registerClick: (uuid) => client.post(`/stations/${uuid}/click`).then((r) => r.data).catch(() => null),
};
